<!-- QuickPlan Main -->
<template>
  <div id="explorePage" class="guide_main">
    <el-row  class="step_indicator">

      <el-col :span="3">
        <router-link :to="ROUTE_PATH.GUIDE.ROOT">
          <el-button type="text" style="margin-left:24px;font-size:18px;">← 回到首頁</el-button>
        </router-link>
      </el-col>
      <el-col :span="18">
        <el-steps  :active="currentStep-1" finish-status="finish">
          <el-step title="" description=""></el-step>
          <el-step title="" description=""></el-step>
          <el-step title="" description=""></el-step>
          <el-step title="" description=""></el-step>
          <el-step title="" description="" icon="el-icon-check"></el-step>
        </el-steps>
      </el-col>
    </el-row>
    <div>
    </div>
    <Consultation
        v-if="showConsultationForm"
        :showConsultationForm.sync="showConsultationForm"
        :hasSendConsultation.sync="hasSendConsultation"
        :bus="bus"
    >
    </Consultation>
    <div class="step_content" >
      <!-- 目前的transition是右滑左 -->
      <transition mode="out-in"
        :enter-active-class="enterTransition"
        :leave-active-class="leaveTransition">
        <component
          :is="`step${currentStep}`"
          :loading.sync="isCalculation"
          :path="path"
          :selectedDataFromGuide.sync="selectedDataFromGuide"
          :calculationResultFromGuide.sync="calculationResultFromGuide"
          class="step_element"
        />
      </transition>

    </div>
    <div class="step_controller">
      <el-button :style="{visibility: prevBtnVisibility}" id="guide_btn_prev" @click="prev" round>← 上一步</el-button>

      <div v-show="goCalculateVisibility && !isCalculation" style="display:inline-flex">
        <!-- <el-button :loading="isSendingConsultation" id="guide_btn_contact" @click='sendConsultation' round :disabled="isSendingConsultation">
          <i class='fas fa-comment-dots'></i>
          諮詢顧問
        </el-button> -->
        <el-button
          :loading="isExportingPdf"
          id="guide_btn_export"
          @click="handleExport"
          round
          :disabled="isExportingPdf"
        >
          <i class='fas fa-print'></i>
          輸出規劃書
        </el-button>
        <el-button id="guide_btn_goCalculate"
          @click="goCalculatePage"
          type="primary"
          :disabled="this.$lodash.isEmpty(this.calculationResultFromGuide)"
          round
        >
          <i class='fas fa-chart-bar'></i>
          將結果帶入計算頁面，快速規劃
        </el-button>
        <el-button
          v-if="this.showBackToCalculation === true"
          id="guide_btn_goBackCalculate"
          @click="goBackCalculatePage"
          type="warning"
          round
        >
          <i class='fas fa-reply'></i>
          返回計算頁面
        </el-button>
      </div>

      <el-button v-if="nextBtnVisibility" id="guide_btn_next" @click="next" round type="primary">下一步 →</el-button>
    </div>
    <Copyright></Copyright>
  </div>
</template>

<script>
// 不能刪, 裡面有轉場用的 CSS
// eslint-disable-next-line no-unused-vars
import animate from 'animate.css'
import { ROUTE_PATH } from '../../router/Const'
import Step1 from './steps/Step1'
import Step2 from './steps/Step2'
import Step3 from './steps/Step3'
import Step4 from './steps/Step4'
import Step5 from './steps/Step5'
import Consultation from '../Consultation'
import Vue from 'vue'
import Copyright from '@/views/Guide/components/Copyright'

import downloadPdf from '@/utils/domToPdf'
import report from '@/api/report'
import { mapActions, mapState } from 'vuex'

const CONFIG = {
  MIN_STEP: 1,
  MAX_STEP: 5
}

export default {
  name: 'PurposePathWrapper',
  data () {
    return {
      ROUTE_PATH,
      path: 'purpose',
      enterTransition: '',
      leaveTransition: '',
      isCalculation: true,
      isExportingPdf: false,
      isSendingConsultation: false,
      loading: true,
      showBackToCalculation: false,
      selectedDataFromGuide: {},
      calculationResultFromGuide: {},
      // for Consultation component
      showConsultationForm: false,
      hasSendConsultation: false,
      // communicate with Consultation component
      bus: new Vue()
    }
  },
  components: {
    Step1,
    Step2,
    Step3,
    Step4,
    Step5,
    Consultation,
    Copyright
  },
  computed: {
    ...mapState('speedCalculation2', ['isFromCalculation']),
    currentStep: function () {
      return +this.$route.params.currentStep
    },
    prevBtnVisibility: function () {
      return this.currentStep > CONFIG.MIN_STEP ? 'visible' : 'hidden'
    },
    nextBtnVisibility: function () {
      return this.currentStep < CONFIG.MAX_STEP && this.checkIfOptionFilled()
    },
    goCalculateVisibility: function () {
      return this.currentStep === CONFIG.MAX_STEP
    }

  },
  watch: {
    $route (to, from) {
      let toStep = to.params.currentStep
      let fromStep = from.params.currentStep

      if (fromStep > toStep) {
        this.enterTransition = 'animated fadeInLeft fast'
        this.leaveTransition = 'animated fadeOutRight faster'
      } else if (fromStep < toStep) {
        this.enterTransition = 'animated fadeInRight fast'
        this.leaveTransition = 'animated fadeOutLeft faster'
      } else {
        this.enterTransition = 'animated fadeIn'
        this.leaveTransition = 'animated fadeOut'
      }
    }
  },
  methods: {
    ...mapActions('speedCalculation2', ['setProductLineStatus', 'setResultFromGuide', 'setIsFromCalculation']),
    ...mapActions(['updateGuideSpeedSelectedData', 'updateSpeedCalculationResult']),
    next () {
      this.$router.push(ROUTE_PATH.GUIDE.PURPOSE + Math.min(CONFIG.MAX_STEP, this.currentStep + 1))
    },
    prev () {
      this.$router.push(ROUTE_PATH.GUIDE.PURPOSE + Math.max(CONFIG.MIN_STEP, this.currentStep - 1))
      this.isCalculation = true
    },
    handleExport () {
      this.isExportingPdf = true
      var elements = [
        document.getElementById('paging-for-pdf-1'),
        document.getElementById('paging-for-pdf-2'),
        document.getElementById('paging-for-pdf-3')
      ]
      var options = {
        filename: 'report.pdf',
        overrideWidth: 1000,
        marginTops: [100, 100, 100]
      }
      downloadPdf(elements, options, 'save').then(() => {
        this.isExportingPdf = false
      }).catch(() => {
        this.$message.error('發生錯誤')
        this.isExportingPdf = false
      })
    },
    sendConsultation () {
      this.isSendingConsultation = true

      const elements = [
        document.getElementById('paging-for-pdf-1'),
        document.getElementById('paging-for-pdf-2'),
        document.getElementById('paging-for-pdf-3')
      ]
      const options = {
        filename: report.filename,
        overrideWidth: 1000,
        marginTops: [100, 0]
      }

      const userFillFormPromise = new Promise((resolve, reject) => {
        this.showConsultationForm = true

        const USER_FILLED_FORM = 'userFilledForm'
        const handler = (data) => {
          this.bus.$off(USER_FILLED_FORM, handler)
          const pdfPromise = downloadPdf(elements, options, 'file')
          resolve([pdfPromise, data])
        }
        this.bus.$on(USER_FILLED_FORM, handler)
      })

      userFillFormPromise.then((dataArr) => {
        const { name, company, email, tel, salesContact, content } = dataArr[1]
        const pdfPromise = dataArr[0]
        pdfPromise.then((data) => {
          this.bus.$emit('pdfProduced')
          data.append('company', company)
          data.append('name', name)
          data.append('email', email)
          data.append('tel', tel)
          data.append('sales_contact', salesContact)
          data.append('content', content)
          return report.sendConsultation(data)
        }).then(() => {
          this.isSendingConsultation = false
          this.$message.success('已送出諮詢!')
        }).catch(() => {
          this.$message.error('發生錯誤')
          this.isSendingConsultation = false
        })
      })
    },

    /**
     * 連到計算頁面，並將導引計算的結果帶過去
     */
    goCalculatePage () {
      // 將選項存到計算頁面可以access的地方
      this.updateGuideSpeedSelectedData(this.selectedDataFromGuide)

      // 將結果存到計算頁面可以access的地方
      this.updateSpeedCalculationResult(this.calculationResultFromGuide)
      this.setResultFromGuide(true)

      // 告訴計算頁面哪些產品線的資料是由導引流程帶過去的
      this.setProductLineStatusForProductLines()

      this.$router.push(ROUTE_PATH.CALCULATION)
    },

    /**
     * 連到計算頁面，不把導引流程的結果帶過去
     */
    goBackCalculatePage () {
      this.$router.push(ROUTE_PATH.CALCULATION)
    },

    setProductLineStatusForProductLines () {
      const purposeStateType = this.$store.state.guide.purpose.purposeType
      let productLineNewStatus = {}
      productLineNewStatus['LINEToday'] = (purposeStateType['line_rate'] !== '0.0') ? 1 : 0
      productLineNewStatus['SuperImpact'] = (purposeStateType['si_rate'] !== '0.0') ? 1 : 0
      productLineNewStatus['SuperView'] = (purposeStateType['sv_rate'] !== '0.0') ? 1 : 0
      this.setProductLineStatus(productLineNewStatus)
    },
    checkIfOptionFilled () {
      let result
      const purposeState = this.$store.state.guide.purpose
      switch (this.currentStep) {
        case 1:
          result = purposeState.purposeType.id !== -1
          break
        case 2:
          result = purposeState.targetType.id !== -1
          break
        case 3:
          result = purposeState.targetOption.id !== -1
          break
        case 4:
          result = purposeState.schedule.length === 2
          break
      }
      return result
    }
  },
  mounted () {
    this.showBackToCalculation = this.isFromCalculation
    this.setIsFromCalculation(false)
  }
}
</script>

<style lang="scss">
.el-main{
  // background-size: 620px;
  // background-repeat: no-repeat;
  // background-position: 130% 140%;
  // background-image: url(../assets/images/bg5.jpg);
  background-size: cover;
  background-position: center;
  // background-position: right;

  // background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  background-position: bottom;
}
#guide_btn_goCalculate, #guide_btn_goBackCalculate {
  font-size: 16px;
}
#guide_btn_goBackCalculate {
  background: #e89022;
}
.step_indicator .el-steps{
  max-width:800px;
  width:100%;
  display:flex;
  margin: 0 auto;
}
.el-step.is-horizontal .el-step__line{
  top:23px;
}
.el-step__icon.is-text{
  background:#c6c6c6;
  border:none;
  width:48px;
  height:48px;
  font-size:18px;
  color:#fff;
}
.el-step__head.is-process .el-step__icon.is-text,.el-step__head.is-process .el-step__icon.is-icon{
  background:#fff;
  border:2px solid #4da1ff;
  color:#4da1ff;
}
.el-step__head.is-finish .el-step__icon.is-text{
  background:#4da1ff;
}
.el-step__icon.is-icon{
  background:#c6c6c6;
  width:48px;
  height:48px;
  color:#fff;
  border:none;
  border-radius:50%;
}
.el-step__head.is-process  .el-step__icon.is-icon{
  background:#fff;
}
.step_indicator ul{
  width:400px;
  display:flex;
  margin: 0 auto;
  padding:0;
}
.step_indicator li{
  background:red;
  list-style:none;
  width:20%;
  text-align:center;
  border-radius: 100%;
  margin:20px;
  position:relative;
}
.step_indicator li:before{
  content: "";
  display: block;
  padding-top: 100%; /* initial ratio of 1:1*/
}
.step_indicator li .number{
  position:absolute;
  top:0;
  text-align: center;
}
.step_controller {
  display:flex;
  justify-content: space-between;
  // padding: 0 24px;
}
.step_controller .el-button{
  height:40px;
}
.guide_main{
  display:flex;
  flex-direction: column;
  height:100%;
  margin: 0 -20px;
}
.step_indicator{
  min-height:80px;
  display:flex;
}
.step_content{
  flex-grow: 1;
  overflow-y:auto;
  // display: flex;
  align-items: baseline;
  // background:#e5e9f2;
  // margin: 0 -16px;
  overflow-x: hidden;
  display:flex;
}
.step_controller{
  padding: 20px 20px 0;
  min-height:60px;
}
.step_controller .el-button.el-button--default{
  border-color:#4da1ff;
  color:#4da1ff;
}
.container_layout{
  height: 100%;
  max-width:1060px;
  width:100%;
  margin:0 auto;
}
.el-input-number .el-input__inner{
  padding:0 50px!important;
}
.guide_title{
  // title置頂目前對切換動畫會有負效果
  text-align:center;
  font-size:24px;
  margin-bottom:12px;
}
.guide_title.fix_top{
  z-index: 100;
  position: absolute;
  width: 100%;
  left: 0;
}
.guide_title.fix_top>div{
  background: #fcfdffcc;
  width: 300px;
  margin: 0 auto;
  float: none;
  box-shadow: 0px 0px 20px 10px #fcfdffcc;
}
.el-aside.sidebar.hide{
  width: 0px !important;

}
.el-aside.sidebar{
  transition: width 1s;
}
.animated {
  // animation-duration: 0.5s;
  // animation-delay: 2s;
  // animation-iteration-count: infinite;
}
.option_item_other{
  text-decoration:none;
  color:#4da1ff;
  text-align:center;
  display:block;
  margin-top:16px;
  font-weight:bold;
}
.option_item_other:hover{

  text-decoration:underline;
}
</style>
